// Master switch for the subscription/paywall system. Set REACT_APP_SUBSCRIPTION_ENABLED=true
// to re-enable the Ora+ subscription gating (Phase 3). When false (default), the app is
// fully freemium: every feature is accessible and subscription UI is hidden.
export const SUBSCRIPTION_ENABLED =
  process.env.REACT_APP_SUBSCRIPTION_ENABLED === 'true';
